













import { Vue, Component, Prop } from 'vue-property-decorator'
import { Content } from '@/types/interfaces/content'

@Component
export default class DeleteContentModal extends Vue {
  @Prop(String) readonly modalId!: string
  @Prop(Object) readonly content!: Content

  private onDeleteContent() {
    this.$emit('modalDelete')
  }
}
